export default __webpack_public_path__ + "static/media/logo.bdea6944.png";